// /* eslint-disable */

// import { Box } from "@mui/material";
// import { ArticleContentWrapper } from "./css";

// const dummyText = `<h1>Health Insurance: Buy Medical Insurance Plans</h1><p>Navigating the world of health insurance can feel overwhelming, but understanding your options is essential for protecting your health and finances. Whether you are looking to buy medical insurance for the first time or seeking to upgrade your existing health insurance coverage, this guide provides valuable insights into the world of health insurance policies.</p><h2>Understanding Health Insurance</h2><h3>What is Health Insurance?</h3><p>Health insurance is a contract between an individual or a group and an insurance company to provide health insurance coverage for medical expenses. In exchange for health insurance premiums, the insurance company agrees to pay for all or a portion of your medical costs, as outlined in your health policies. The core idea behind health insurance is to <strong>protect individuals from the high and often unpredictable costs of healthcare</strong>. You can buy health insurance to safeguard your finances and ensure access to necessary medical care when you need it.</p><h3>Types of Health Insurance Plans</h3><p>There are various types of health insurance plans available in the market, each designed to cater to different needs and preferences. Some common types include Health Maintenance Organizations (HMOs), Preferred Provider Organizations (PPOs), and Exclusive Provider Organizations (EPOs). HMOs typically require you to select a primary care physician who coordinates your care and referrals. PPOs offer more flexibility, allowing you to see specialists without a referral but potentially at a higher cost. Understanding the differences between these health insurance plans is crucial to <strong>choosing the best health insurance for your unique situation</strong>. Comparing health insurance plans online can help you assess the pros and cons of each type.</p><h3>Importance of Health Insurance Policies</h3><h2>Buying Health Insurance</h2><ul><li>Health insurance premiums, deductibles, co-pays, and the overall costs.</li><li>What the plan covers, including hospitalization, outpatient care, prescription drugs, and preventive services.</li></ul>`;

// const StepperArticleContentBody = ({ formData, updateForm }) => {
//   return (
//     <ArticleContentWrapper>
//       <Box className="ContentWrapper" dangerouslySetInnerHTML={{ __html: dummyText }} />
//     </ArticleContentWrapper>
//   );
// };

// export default StepperArticleContentBody;

/* eslint-disable */
import { Box, CircularProgress, Typography } from "@mui/material";
import DOMPurify from "dompurify";
import { ArticleContentWrapper } from "./css";

const isValidHtml = (str) => typeof str === "string" && str.trim().startsWith("<");

const StepperArticleContentBody = ({ formData }) => {
  const html = formData?.articleHtml || "";
  if (!isValidHtml(html)) {
    return (
      <ArticleContentWrapper>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: 2, py: 10 }}>
          <CircularProgress />
          <Typography variant="body2" color="text.secondary">Generating article, please wait…</Typography>
        </Box>
      </ArticleContentWrapper>
    );
  }
  return (
    <ArticleContentWrapper>
      <Box className="ContentWrapper" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />
    </ArticleContentWrapper>
  );
};

export default StepperArticleContentBody;
